import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

if (env('VUE_APP_SENTRY_DSN')) {
    Sentry.init({
        dsn: env('VUE_APP_SENTRY_DSN'),
        environment: env('VUE_APP_ENV'),
        release: process.env.GIT_RELEASE,
        integrations: [
            new Integrations.Vue({
                Vue,
                attachProps: true,
            }),
        ],
    })
}
